import React from 'react';
import MDInput from 'components/MDInput';

export default function CellInput(props) {
  const getColor = (type, editable, theme) => {
    if(editable === false) {
      return theme.palette.grey[500];
    }else if(type === 'CORRECTED' || type === 'ADDED') {
      return theme.palette.text.dark;
    } else {
      return theme.palette.grey[500];
    }
  };

  const getFontWeight = (type, editable) => {
    if(editable === false) {
      return 400;
    }else if(type === 'CORRECTED' || type === 'ADDED') {
      return 500;
    } else {
      return 400;
    }
  };

  var sxInput = (theme) => {
    return {
      textAlign: 'left',
      fontSize: '14px',
      fontFamily: 'Roboto,Helvetica;',
      fontWeight: () => getFontWeight(props.type, props.editable),
      color: (theme) => getColor(props.type, props.editable, theme),
    };
  };
  if (props.align === 'right')
    sxInput = (theme) => {
      return {
        textAlign: 'right',
        fontSize: '14px',
        fontFamily: 'Roboto,Helvetica;',
        fontWeight: () => getFontWeight(props.type, props.editable),
        color: (theme) => getColor(props.type, props.editable, theme),
      };
    };
  return (
    <React.Fragment>
      <MDInput
        sx={{
          color: (theme) => {
            getColor(props.type, props.editable, theme);
          },
          outline: 'none',
          input: sxInput,
          fontSize: '20px',
          fontFamily: 'Roboto,Helvetica;',
          fontWeight: () => getFontWeight(props.type, props.editable),
        }}
        {...props}
        label={props.label}
        size="small"
      >
        {props.value}
      </MDInput>
    </React.Fragment>
  );
}
